exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-view{z-index:1000;position:fixed;top:0;left:0;right:0;bottom:0;display:flex;justify-content:center;align-items:center;overflow:auto;pointer-events:none;animation-duration:.2s;animation-name:modal-background-fadein;opacity:0\n}\n.modal-view>*{pointer-events:initial\n}\n.modal-view.modal-background{pointer-events:initial;background-color:rgba(0,0,0,.5)\n}\n.modal-view.open{opacity:1\n}\n@keyframes modal-background-fadein{\nfrom{background-color:rgba(0,0,0,0)\n}\nto{background-color:rgba(0,0,0,.5)\n}\n}", ""]);

// exports
